import React from "react";
import styles from './index.module.css';

const ThemeSwitch = (props) => {

    return (
        <label for="theme" className={styles["theme"]} style={{transform: 'scale(0.7)'}}>
	<span className={styles["theme__toggle-wrap"]}>
		<input id="theme" checked={props.dark} className={styles["theme__toggle"]} type="checkbox" role="switch" name="theme" value="dark" onChange={(e) => {
		localStorage.setItem('chesscloud_theme', !props.dark ? '0' : '1');
        props.setDark(!props.dark);
        }} />
		
		<span className={styles["theme__icon"]}>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
			<span className={styles["theme__icon-part"]}></span>
		</span>
	</span>
    
</label>
    )
} 

export default ThemeSwitch;